import { Directive, HostListener, Input } from '@angular/core';

export enum AvoidCopyAndPasteActions {
  paste = 'paste',
  copy = 'copy',
  cut = 'cut',
}

@Directive({
  selector: '[avoidCopyPaste]',
  standalone: false,
})
export class AvoidCopyPasteDirective {
  @Input() avoidActions: AvoidCopyAndPasteActions[] = [];
  @Input() avoidAllActions: boolean = false;

  @HostListener('paste', ['$event'])
  public onPaste(e: KeyboardEvent) {
    if (this.avoidAllActions || this.avoidActions.includes(AvoidCopyAndPasteActions.paste)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  @HostListener('copy', ['$event'])
  public onCopy(e: KeyboardEvent) {
    if (this.avoidAllActions || this.avoidActions.includes(AvoidCopyAndPasteActions.copy)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  @HostListener('cut', ['$event'])
  public onCut(e: KeyboardEvent) {
    if (this.avoidAllActions || this.avoidActions.includes(AvoidCopyAndPasteActions.cut)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}
